import { defineMessages } from 'react-intl'

export const lang = defineMessages({
  noUserFound: {
    id: 'donater.no_user',
    defaultMessage: 'Streamer not found',
  },
})
